import React, { useEffect } from 'react';
import Home from './Home';
import About from './About';
import Services from './Services';
import Blog from './Blog';
import Contact from './Contact';

const MainPage = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 1024);

  // 1. Listen to window resizing to toggle preview mode on mobile devices
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 2. Scrollspy: Highlight sidebar links dynamically based on scroll position (Desktop only)
  useEffect(() => {
    if (window.innerWidth >= 1024) {
      const sections = ['home', 'about', 'services', 'blog', 'contact'];
      const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            // Notify Sidebar component of section change without modifying URL hash bar
            window.dispatchEvent(new CustomEvent('sectionchange', { detail: id }));
          }
        });
      }, observerOptions);

      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
      });

      return () => observer.disconnect();
    }
  }, []);

  return (
    <div className="main-page-scroll-container">
      <div id="home">
        <Home />
      </div>
      <div id="about">
        <About isPreview={isMobile} />
      </div>
      <div id="services">
        <Services isPreview={isMobile} />
      </div>
      <div id="blog">
        <Blog isPreview={isMobile} />
      </div>
      <div id="contact">
        <Contact />
      </div>
    </div>
  );
};

export default MainPage;
